import { useTranslations } from 'next-intl';
import React from 'react';

import Button from '@/components/button/Button';
import { ButtonStyle } from '@/components/button/ButtonStyle.enum';

import { Filter } from '@/types/filter/ActiveFilters.types';

import { cn } from '@cineamo/ui/src/helpers/cn';

type FilterGroupProps = {
    classNameFilterItem?: string;
    label?: string;
    filters: Filter[];
    onFilterClick: (filter: Filter) => void;
};

const FilterGroup: React.FC<FilterGroupProps> = ({ classNameFilterItem, label, filters, onFilterClick }) => {
    const t = useTranslations();
    return (
        <div className="flex flex-col space-y-8">
            {label && <span className="text-body-bold-12">{label}</span>}
            <div className="flex flex-wrap gap-[6px] overflow-auto">
                {filters.map((filter) => {
                    const name =
                        typeof filter.name === 'string' && t.has(filter.name) ? t(filter.name.toString()) : filter.name;
                    return (
                        <Button
                            key={`FilterButton#${name}`}
                            // `none`, because the default style appends its own primary background after
                            // `className`, so the inactive colors below would never apply.
                            style={ButtonStyle.none}
                            className={cn(
                                classNameFilterItem,
                                '!px-8 !py-0 normal-case border-2 border-transparent',
                                filter.isActive
                                    ? 'bg-[var(--primary-color)] text-[var(--on-primary-color)]'
                                    : 'bg-[rgba(var(--on-surface-color-rgb),0.2)] text-[var(--on-surface-color)]'
                            )}
                            labelClassName="text-body-bold-12"
                            onClick={() => onFilterClick?.(filter)}>
                            {name}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
};

export default FilterGroup;
